import { styled } from '@mui/material/styles';

export const RoomBtn = styled('div')({
  width: 250,
  margin: '0 auto',
});

// Root + input styles (originally passed to realmDrop's classes prop). We
// retain them as exported plain-class names so the realmDrop component can
// still apply them as className strings.
export const SUBS_ROOT_CLASS = 'subs-root';
export const SUBS_INPUT_CLASS = 'subs-input';

// Wrapper that applies the original classes.root and classes.input styling to
// the realmDrop nested elements via descendant selectors.
export const RoomBtnWrapper = styled('div')(({ theme }) => ({
  width: 250,
  margin: '0 auto',
  '& .subs-root': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 4,
  },
  '& .subs-input': {
    color: theme.palette.common.white,
    '&::placeholder': {
      color: theme.palette.common.white,
      opacity: 1,
    },
  },
}));

export const HighlightContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: 6,
  border: `2px solid ${theme.palette.common.black}`,
  transition: 'background-color 0.3s ease',
}));

// Subscore grid items (used by SubScoreCollapse)
export const GridItem = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isHighlighted',
})(({ theme, isHighlighted }) => ({
  width: 120,
  height: 120,
  position: 'relative',
  backgroundColor: 'rgba(0,0,0,0.2)',
  margin: `0px ${theme.spacing(1)} ${theme.spacing(1)} 0px`,
  ...(isHighlighted && {
    border: '2px solid black',
    transition: 'background-color 0.3s ease',
  }),
}));

export const GridText = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: 'rgba(0,0,0,0.2)',
  color: theme.palette.common.white,
  padding: 3,
}));

export const FlexRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
});
